import oraclePaymentsImg from '../assets/projects/oracle-payments-cover.webp';
import oracleHeroPoster from '../assets/case-studies/oracle-payments/highlight-poster.webp';
import qrAskPhone from '../assets/case-studies/qr-pay/ask-phone.webp';
import dittoImg from '../assets/projects/ditto-cover.webp';
import dittoFilmPoster from '../assets/case-studies/ditto/product-poster.webp';
import kitThumb from '../assets/case-studies/kit/ui-compare-thumb.webp';

export const projects = [
  {
    slug: 'oracle-payments',
    image: oraclePaymentsImg,
    imageAlt: 'Oracle Payments dashboard with transaction insights',
    coverLayout: 'oracle-dashboard',
    coverPoster: oracleHeroPoster,
    coverFilm: `${process.env.PUBLIC_URL || ''}/films/oracle/index.html?teaser=1`,
  },
  {
    slug: 'qr-pay',
    image: qrAskPhone,
    imageAlt: 'Oracle QR Pay check, tip, and split screens',
    /* The full hero film plays as the card thumbnail (scan → split → tip → pay → paid) */
    coverLayout: 'qr-film',
    coverTeaser: 'full',
    coverPoster: qrAskPhone,
  },
  {
    slug: 'ditto',
    image: dittoImg,
    imageAlt: 'Ditto game board: two players race to find the toy on both sides',
    coverLayout: 'ditto-duo',
    coverPoster: dittoFilmPoster,
    coverFilm: `${process.env.PUBLIC_URL || ''}/films/ditto/product.html?teaser=9.5,19.5`,
  },
  {
    slug: 'kit',
    image: kitThumb,
    imageAlt:
      'Kit compare board: three goalkeeper recruits side by side with their trade-offs',
    coverLayout: 'kit-desktop',
    coverPoster: kitThumb,
    /* Live teaser cut from the hero film: mark a must-have → trade-offs update → coaches split */
    coverFilm: `${process.env.PUBLIC_URL || ''}/films/kit-compare/index.html?teaser=4.9,12.4`,
  },
];

/** Homepage / reading order for case studies. */
export const caseStudyOrder = ['oracle-payments', 'qr-pay', 'kit', 'ditto'];

/** Next case studies in homepage order (wraps; excludes current). */
export const getNextProjects = (currentSlug, count = 2) => {
  const live = caseStudyOrder
    .map((slug) => projects.find((p) => p.slug === slug))
    .filter(Boolean);
  if (!live.length) return [];
  const index = live.findIndex((p) => p.slug === currentSlug);
  const start = index < 0 ? 0 : index + 1;
  const out = [];
  for (let i = 0; i < Math.min(count, live.length - (index < 0 ? 0 : 1)); i += 1) {
    out.push(live[(start + i) % live.length]);
  }
  return out;
};
